module.exports = __webpack_public_path__ + "static/img/table.d33d870.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/table.png
// module id = OgXh
// module chunks = 63